module.exports = __webpack_public_path__ + "static/media/pattern.9e6e6ab2.png";